<template>
  <div class="offline-empty-state">
    <EmptyList
      icon="mdi-wifi-off"
      title="No tienes conexión"
      description="Esta sección necesita internet. Revisa tu conexión e inténtalo de nuevo."
      hide-button
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import EmptyList from '@/components/baseComponents/EmptyList.vue'

export default defineComponent({
  name: 'OfflineEmptyState',

  components: {
    EmptyList,
  },
})
</script>

<style scoped>
.offline-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: min(60vh, 480px);
  height: 100%;
  padding: 1.5rem;
  box-sizing: border-box;
}
</style>
